import { ParserInput } from 'src/services/DB';
import { dataAndID } from 'src/store/parsers/dataandid';
import { Collection } from 'src/types/models/collection.model';
export function collectionParser(doc: ParserInput): Collection | null {
  return dataAndID<Collection>(doc);
}
